import { Checkbox, FormControlLabel } from "@mui/material"
import { ChangeEvent, useMemo } from "react";
import { BooleanProperty } from "types/Property";
import { TooltipFormControl } from "./TooltipFormControl"

export type BooleanFormControlProps = {
    value?: boolean | "true" | "false"
    property: BooleanProperty,
    onChange?: (newValue: boolean) => void
}

export function BooleanFormControl({ value, property, onChange }: BooleanFormControlProps) {
    const boolValue = useMemo(() => {
        if (typeof value === "boolean")
            return value;

        if (value === "true")
            return true;

        if (value === "false")
            return false;

        return property.default || false;
    }, [value, property.default])

    if(property.hidden){ return null; }
    
    return <TooltipFormControl property={property} >
        <FormControlLabel
            control={
                <Checkbox
                    disabled={property.readOnly}
                    aria-label={`field-${property.name}`}
                    id={`field-${property.name}`}
                    data-testid={`field-${property.name}`}
                    checked={boolValue}
                    required={property.required}
                    onChange={handleChange}
                />
            }
            label={property.displayName || property.name}
        />
    </TooltipFormControl>

    function handleChange(e: ChangeEvent<HTMLInputElement>) {
        if (property.readOnly) {
            console.warn(`Field ${property.name} is read-only and cannot be changed.`);
            return;
        }

        if (onChange)
            onChange(e.target.checked);

    };
}